import React from "react";

export default function IllMax() {
  return <div>illmax</div>;
}
